import React from 'react';
import Layout from '@rezdy/components/Layout/DarkCentered';
import auth from '../../services/auth';
import Button from '@rezdy/components/Button';
import { Article, Aside, Body } from '@rezdy/components/Layout/Article/Styled';
import SecondaryAction from '../../components/SignUpV2/SecondaryAction';
import routing from '../../services/routing';
import { SIGN_IN } from '../../constants/routes';
import Loading from '../../components/Loading';
import { extractRequestParams } from './util';
import { TestimonialCard } from './TestimonialCard';
import TextStyle from '@rezdy/components/TextStyle';
import { H4 } from '@rezdy/components/Heading';
import { ChangeEmailError, ErrorCode } from './Errors';
import { ContactSupport } from '../../components/ContactSupport';
import { withTranslation, WithTranslation } from 'react-i18next';

interface VerifyNewEmailState {
    error: ErrorCode | null | undefined;
    processing: boolean;
    email: string;
}

export class VerifyNewEmail extends React.Component<{} & WithTranslation, VerifyNewEmailState> {
    state: VerifyNewEmailState = {
        error: null,
        processing: true,
        email: '',
    };

    async componentDidMount() {
        const { code, username, newEmail } = extractRequestParams();
        if (!code || !username || !newEmail) {
            this.setState(state => ({
                ...state,
                error: 'INVALID_VERIFICATION_CODE',
            }));
            return;
        }
        this.setState({ email: username });
        try {
            await auth.verifyNewEmail({ code, username, newEmail });
            this.setState({ processing: false });
        } catch (error) {
            this.setState(state => ({
                ...state,
                processing: false,
                error: (error as Error).message as ErrorCode,
            }));
        }
    }

    handleClick = () => {
        routing.push(SIGN_IN);
    };

    render() {
        const { i18n } = this.props;

        if (this.state.error) {
            return (
                <Layout secondaryAction={<SecondaryAction />}>
                    <Article>
                        <Body>
                            <ChangeEmailError errorCode={this.state.error} email={this.state.email} {...this.props} />
                            <ContactSupport />
                        </Body>
                        <Aside>
                            <TestimonialCard />
                        </Aside>
                    </Article>
                </Layout>
            );
        }

        if (this.state.processing) {
            return (
                <Layout>
                    <Loading />
                </Layout>
            );
        }

        return (
            <Layout secondaryAction={<SecondaryAction />}>
                <Article>
                    <Body>
                        <TextStyle align="left">
                            <H4>{i18n.t('verifyNewEmail.heading')}</H4>
                        </TextStyle>
                        <Button onClick={this.handleClick} style={{ width: '200px' }}>
                            {i18n.t('primaryAction', { context: 'loginDashboard' })}
                        </Button>
                    </Body>
                    <Aside>
                        <TestimonialCard />
                    </Aside>
                </Article>
            </Layout>
        );
    }
}

export default withTranslation()(VerifyNewEmail);
